import { useSelector } from "react-redux";
import ReusableDatagrid from "../components/ReusableDatagrid";

const columnsConfig = [
  {
    field: "action",
    headerName: "Actions for PPS",
    width: 460,
    type: "select",
    label: "Select Action",
    options: [
      { value: "Report OAs to client", label: "Report OAs to client" },
      { value: "Follow Due Dates", label: "Follow Due Dates" },
      { value: "Follow Final Due Dates", label: "Follow Final Due Dates" },
      { value: "Prepare OA response shells", label: "Prepare OA response shells" },
      { value: "Assignment and Declaration", label: "Assignment and Declaration" },
      { value: "Send Projected Publication, Broadening/Reissue Letter", label: "Send Projected Publication, Broadening/Reissue Letter" },
      { value: "Prepare 12 month US/FF conversion letters and 30- month conversion letters", label: "Prepare 12 month US/FF conversion letters and 30- month conversion letters" },
      {value: "Other", label: "Other"}
    ],
  },
  {
    field: "wsgrResponsible",
    headerName: "WSGR Responsible?",
    width: 180,
    label: "Select Yes/No",
    type: "select",
    options: [
      { value: "Yes", label: "Yes" },
      { value: "No", label: "No" },
    ],
  },
  {
    field: "matters",
    headerName: "Family No(s)",
    width: 260,
    placeholder: "Enter Family No(s)",
  },
  {
    field: "notes",
    headerName: "Notes",
    width: 260,
    placeholder: "Enter Notes",
  },
];

export default function PpsInstructions({ mode }) {
  const savedData = useSelector((state) => state.kotClient.ppsInstructions);
  return <ReusableDatagrid title="Instructions for PPS" columnsConfig={columnsConfig} initialRows={savedData} section={"ppsInstructions"} mode={mode} />;
}
